import PropTypes from 'prop-types';
import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
  },
});

function MyScrollView(props) {
  const { children, containerStyle, contentContainerStyle, testID } = props;

  const container = containerStyle ? [containerStyle, styles.container] : styles.container;
  const contentContainer = contentContainerStyle
    ? [contentContainerStyle, styles.contentContainer]
    : styles.contentContainer;

  return (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={contentContainer}
      style={container}
      testID={testID || 'scroll-view'}
    >
      {children}
    </ScrollView>
  );
}

MyScrollView.propTypes = {
  testID: PropTypes.string,
  containerStyle: PropTypes.any, // createStylesheet is number but works as object
  contentContainerStyle: PropTypes.any,
  children: PropTypes.node,
};

export default MyScrollView;
